import {
  ReservationQuestionDto,
  ReservationQuestionOptionDto,
} from "@/api/generated/generatedTypes";
import { EventReservationFormValues } from "@/pages/EventReservation.page"; // Assuming this path is correct
import { Stack, Textarea, useMantineTheme } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { EventAnswerOptionsList } from "./EventAnswerOptionsList";
import { getPathForReservationQuestion } from "./utils"; // Import the shared utility

interface EventQuestionAndAnswerResolverProps {
  currentQuestion: ReservationQuestionDto;
  form: UseFormReturnType<EventReservationFormValues>;
  onSelectSingle: (option: ReservationQuestionOptionDto) => void;
  onSelectMultiple: (option: ReservationQuestionOptionDto) => void;
  customInputValue?: string;
  onCustomInputChange?: (value: string) => void;
}

export function EventQuestionAndAnswerResolver({
  currentQuestion,
  form,
  onSelectSingle,
  onSelectMultiple,
  customInputValue,
  onCustomInputChange,
}: EventQuestionAndAnswerResolverProps) {
  const theme = useMantineTheme();

  const fieldPath = getPathForReservationQuestion(currentQuestion);

  if (currentQuestion.type === "text") {
    return (
      <Textarea
        {...form.getInputProps(fieldPath)}
        placeholder={`(e.g.: "호주를 히치하이킹으로 여행했어요!" / "하루 6끼 가능!" / "10년만에 퇴사함!" / "사실 나는 극 I인데 다들 E래요")`}
        w="100%"
        autosize
        minRows={4}
        styles={{
          input: {
            backgroundColor: theme.black,
            color: theme.white,
          },
        }}
      />
    );
  }

  if (
    (currentQuestion.type === "select_single" || currentQuestion.type === "select_multiple") &&
    currentQuestion.options
  ) {
    const selectedValue = form.getInputProps(fieldPath).value;
    return (
      <Stack w="100%">
        <EventAnswerOptionsList
          currentQuestion={currentQuestion}
          selectedOptions={selectedValue}
          onSelectSingle={onSelectSingle}
          onSelectMultiple={onSelectMultiple}
          customInputValue={customInputValue}
          onCustomInputChange={onCustomInputChange}
        />
      </Stack>
    );
  }

  return null;
}
